/**
 * «Настроить список» (АН-09) для страницы-списка раздела: ведёт на тот же список в «Отчётах»
 * (`/reports/lists/<источник>`), где выбираются колонки, отбор, группировка, итоги и сохранённые виды.
 * Ссылка видна, только если источник открыт этому человеку по правам; внешним участникам — нет.
 */
import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { SlidersHorizontal } from 'lucide-react';
import { useMe } from '../../lib/session';
import { sourcesQuery } from './useListView';

export function ListSettingsLink({ source }: { source: string }) {
  const staff = Boolean(useMe().tenant?.staff);
  const q = useQuery({ ...sourcesQuery, enabled: staff, retry: false });
  if (!staff || !q.data?.some((s) => s.key === source)) return null;
  return (
    <Link
      to="/reports/lists/$source"
      params={{ source }}
      title="Колонки, отбор, группировка, итоги и сохранённые виды этого списка"
      className="inline-flex h-11 items-center gap-2 rounded-md border border-line-strong bg-surface px-4 text-[14px] text-ink underline-offset-[3px] hover:underline md:h-10"
    >
      <SlidersHorizontal className="size-4" aria-hidden />
      Настроить список
    </Link>
  );
}
